import type { CookieConsentConfiguration } from "@/types/cookie-consent-configuration";
import type { DeepPartial } from "@/types/deep-partial";

import { deepMerge } from "@/functions/deep-merge";
import { defaultConfiguration } from "@/constants/configuration";

export function createCookieConfiguration(
  options?: DeepPartial<CookieConsentConfiguration>
): CookieConsentConfiguration {
  return deepMerge(defaultConfiguration, options);
}
